import { all, takeEvery, put } from "redux-saga/effects";
import {
  SEND_LEADSQUARED_INFO,
  SEND_HUBSPOT_INFO,
  SEND_LSQ_WHATSAPP_CONNECTOR,
  GET_LEADSQUARED_INFO,
  GET_HUBSPOT_INFO,
  GET_LSQ_WHATSAPP_CONNECTOR,
  GET_ZOHOCRM_INFO,
  GET_ZOHO_DESK_INFO,
  GET_GOOGLESHEETS_INFO
} from "../constants/MarketPlace";

import {
  saveLeadSquaredInfo,
  saveHubspotInfo,
  saveLSQWhatsappConnector,
  saveZohoCRMInfo,
  saveZohoDeskInfo,
  saveGoogleSheetsInfo,
} from "../actions/MarketPlace";

import ApiService from "../../Services/ApiService";
import { toastNotification } from "../../utils/toastNotification";

function* sendLeadSquared() {
  yield takeEvery(SEND_LEADSQUARED_INFO, function* (action) {
    try {
      yield ApiService.post(
        `/falcon/leadsquared/install/secret_value`,
        {},
        action.payload
      );
      toastNotification({
        successMessage: "LeadSquared form sent successfully",
      });
    } catch (error) {
      yield console.log(error);
      toastNotification({ errorMessage: "Error" });
    }
  });
}

function* getLeadSquared() {
  yield takeEvery(GET_LEADSQUARED_INFO, function* () {
    try {
      const res = yield ApiService.post(
        "/falcon/leadsquared/getdetails/secret_value"
      );
      yield put(saveLeadSquaredInfo(res));
    } catch (error) {
      yield console.log(error);
    }
  });
}

function* sendHubspot() {
  yield takeEvery(SEND_HUBSPOT_INFO, function* (action) {
    try {
      yield ApiService.post(
        `/falcon/hubspot/install/secret_value`,
        {},
        action.payload
      );
      toastNotification({ successMessage: "Hubspot form sent successfully" });
    } catch (error) {
      yield console.log(error);
      toastNotification({ errorMessage: "Error" });
    }
  });
}

function* getHubspot() {
  yield takeEvery(GET_HUBSPOT_INFO, function* () {
    try {
      const res = yield ApiService.get(
        "/falcon/hubspot/getdetails/secret_value"
      );
      yield put(saveHubspotInfo(res));
    } catch (error) {
      yield console.log(error);
    }
  });
}

// function* sendLsq() {
//   yield takeEvery(SEND_LSQ_WHATSAPP_CONNECTOR, function* (action) {
//     try {
//       yield ApiService.post(
//         `/falcon/hubspot/install/secret_value`,
//         {},
//         action.payload
//       );
//       toastNotification({ successMessage: "Whatsapp form sent successfully" });
//     } catch (error) {
//       yield console.log(error);
//       toastNotification({ errorMessage: "Error" });
//     }
//   });
// }

function* getLsq() {
  yield takeEvery(GET_LSQ_WHATSAPP_CONNECTOR, function* () {
    try {
      const res = yield ApiService.get("/lsq/connector/getdetails/secret_value");
      yield put(saveLSQWhatsappConnector(res));
    } catch (error) {
      yield console.log(error);
    }
  });
}

function* getZohoCRM() {
  yield takeEvery(GET_ZOHOCRM_INFO, function* () {
    try {
      const res = yield ApiService.get("/falcon/zoho/in/install/secret_value/crm");
      yield put(saveZohoCRMInfo(res));
    } catch (error) {
      yield console.log(error);
    }
  });
}

function* getGoogleSheets() {
  yield takeEvery(GET_GOOGLESHEETS_INFO, function* () {
    debugger;
    try {
      const res = yield ApiService.get("/falcon/google-sheets/install/secret_value");
      yield put(saveGoogleSheetsInfo(res));
    } catch (error) {
      yield console.log(error);
    }
  });
}

function* getZohoDesk() {
  yield takeEvery(GET_ZOHO_DESK_INFO, function* () {
    try {
      const res = yield ApiService.get("/falcon/zoho/in/install/secret_value/desk");
      yield put(saveZohoDeskInfo(res));
    } catch (error) {
      yield console.log(error);
    }
  });
}

export default function* rootSaga() {
  yield all([
    sendLeadSquared(),
    sendHubspot(),
    getLeadSquared(),
    getHubspot(),
    getZohoCRM(),
    getZohoDesk(),
    getGoogleSheets(),
    // sendLsq(),
    getLsq(),
  ]);
}
